module.exports = __webpack_public_path__ + "img/icon_nav_topup_hover.c8b51aaf.svg";